export default __webpack_public_path__ + "static/media/ResistorsImg.618f5527.jpg";